export default function CustomButton({ children, ...attributes }) {
  return (
    <button type="button" {...attributes}>
      {children}
    </button>
  );
}
